module.exports = __webpack_public_path__ + "img/max-good-logo-428x180.11af49c2.png";